import { Trans, useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@app/shared/ui/atoms/Common';
import { USER_AGREEMENT_TRANSLATION_KEYS } from '@app/shared/constants/common';

export function UserAgreementSection() {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col gap-6">
      <Heading level={2} className="text-center">
        {t('instructions.user_agreement.title')}
      </Heading>
      {USER_AGREEMENT_TRANSLATION_KEYS.map((key) => (
        <Paragraph key={key} className="whitespace-pre-line font-normal">
          <Trans
            i18nKey={`instructions.user_agreement.${key}`}
            components={{ strong: <strong /> }}
          />
        </Paragraph>
      ))}
    </section>
  );
}
